import Vue from "vue";
import axios from "axios";
export const state = {
  roles: [],
  users: [],
  save_status: false,
};
export const getters = {
  AllRoles: (state) => state.roles.data,
  AllUsers: (state) => state.users.data,
  SaveStatus: (state) => state.save_status,
};

export const mutations = {
  SET_ROLES(state, newValue) {
    state.roles = newValue;
  },
  SET_USERS(state, newValue) {
    state.users = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  addRole({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("roles", payload)
      .then(() => {
        dispatch("fetchRoles");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Role Added Successfuly",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Edit Role
  editRole({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`roles/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchRoles");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Role Edited Successfuly",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Delete Role
  deleteRole({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`roles/${payload.id}`)
      .then(() => {
        dispatch("fetchRoles");
        const message = {
          type: "primary",
          title: "<b>Success Notifications</b>",
          message: "Role Deleted Successfuly",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  addUser({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("users", payload)
      .then(() => {
        dispatch("fetchUsers");
        const message = {
          type: "primary",
          title: "<b>Success Notifications</b>",
          message: "User Added Successfuly",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          console.log(error.response);
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  editUser({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`users/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchUsers");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "User Edited Successfuly",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },
  // Change password
  editPassword({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`userPassword/update`, payload)
      .then(() => {
        dispatch("fetchUsers");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Password changed Successfuly",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  deleteUser({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`users/${payload.id}`)
      .then(() => {
        dispatch("fetchUsers");
        const message = {
          type: "primary",
          title: "<b>Success Notifications</b>",
          message: "Action Was Successfuly",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch((error) => {
        commit("SET_SAVE_STATUS", false);
        let message = {
          type: "error",
          title: "<b>Error Occured</b>",
          message: "Unexpected Error Occured",
        };
        if (error.response.status == 422) {
          const errorData = error.response.data;
          message.title = "<b>" + errorData.msg + "</b>";
          message.message = errorData.error;
        }
        commit("pushNotification", message);
      });
  },

  fetchRoles({ commit }) {
    axios.get(`roles`).then((pos) => {
      commit("SET_ROLES", pos.data);
    });
  },
  fetchUsers({ commit }) {
    axios.get(`users`).then((sta) => {
      commit("SET_USERS", sta.data);
    });
  },
};
